import { Box } from "@chakra-ui/react";
import { IconCheckedSmall } from "components/icons/Icons";

export default function SelectionRadio(props: { checked: boolean }) {
  const { checked } = props;

  return (
    <Box
      w="24px"
      h="24px"
      minW="24px"
      borderRadius="999px"
      border={`1px solid ${checked ? "#3A7BFF" : "#7C8FA3"}`}
      bg={checked ? "#3A7BFF" : "transparent"}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {checked ? <IconCheckedSmall w="14px" h="12px" /> : null}
    </Box>
  );
}
